<template>
  <!-- 全局输入框 -->
  <div class="input-wrap">
    <div class="title">
      {{ props.name }}
    </div>
    <input :type="props.type==false&&props.name=='入会密码'?'password':'text'" :placeholder="$t('请输入') + props.name" :value="modelValue" @input="inputChange">
  </div>
</template>

<script setup>
const emit = defineEmits();

const props = defineProps({
  type: Boolean ,
  name: String,
  modelValue: String
})

function inputChange(e) {
  emit("update:modelValue", e.target.value);
}
</script>

<style scoped>
.input-wrap {
  width: 30.20833vw;
  margin: 0 auto;
}

.input-wrap .title {
  font-size: 0.9375vw;
  line-height: 1.30208vw;
  color: #2F3367;
  font-weight: bold;
  margin-bottom: 0.41666vw;
}

.input-wrap input {
  display: block;
  width: 100%;
  box-sizing: border-box;
  font-size: 0.83333vw;
  line-height: 1.34583vw;
  color: #2F3367;
  padding: 0.72916vw 1.25vw;
  border: 0.05208vw solid #D4D6D8;
  border-radius: 0.20833vw;
}

.input-wrap input::placeholder {
  color: #a8abb2;
}

@media screen and (max-width: 750px) {

  .input-wrap {
    width: 82.93333vw;
  }

  .input-wrap .title {
    font-size: 3.73333vw;
    line-height: 5.33333vw;
    margin-bottom: 1.6vw;
  }

  .input-wrap input {
    font-size: 3.73333vw;
    padding: 2.66666vw 3.2vw;
    border-radius: 0.53333vw;
    border-width: 0.13333vw;
  }

}
</style>
